import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { isInFilter } from "../utils/dateFilter";

export default function ExpenseDashboard({filter, url, user, token }) {
    const [expenses, setExpenses] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate()

    useEffect(() => {
        if (!user) return;

        async function fetchExpenses() {
            try {
                const expRes = await fetch(
                    `${url}/api/expenses/all/${user.main_id}`,
                    {
                        method: "GET",
                        headers: { Authorization: `Bearer ${token}` },
                    }
                );

                if (!expRes.ok) {
                    throw new Error("Failed to load expenses");
                }

                const data = await expRes.json();
                console.log("expense log:", data);

                // ✅ newest first
                setExpenses(data.reverse());
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        }

        fetchExpenses();
    }, [url, user, token]);

    const filteredExpenses = expenses.filter(e =>
        isInFilter(e.createdAt || e.date, filter)
    );
    if (loading)
        return <p className="text-center text-gray-600 py-6">Loading expenses...</p>;

    if (error)
        return <p className="text-center text-red-600 py-6">Error: {error}</p>;

    return (
        <div>
            <div className="flex justify-between gap-2 items-center mb-3">
                <h2 className="text-[20px] font-bold text-[#222] ">
                    Expense Summary
                </h2>
                <button
                    onClick={() => navigate('/expense')}
                    className="text-xs px-2 py-1 border border-blue-600 text-blue-600 rounded-md hover:bg-blue-600 hover:text-white transition">
                    View more
                </button>
            </div>

            <div className="bg-gray-50 rounded p-2 min-h-[120px]">
                <table className="w-full text-sm">
                    <thead className="font-semibold text-gray-700">
                        <tr>
                            <th className="text-left py-1">Invoice #</th>
                            <th className="text-left py-1">Customer Name</th>
                            <th className="text-left py-1">Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredExpenses?.length ? (
                            filteredExpenses.slice(0, 10).map((exp) => (
                                <tr key={exp.invoiceNumber} className="border-t">
                                    <td className="py-2 text-left text-gray-800">{exp.invoiceNumber || "-"}</td>
                                    <td className="py-2 text-left text-gray-800">{exp.customer || "-"}</td>
                                    <td className="py-2 text-left text-gray-800">₹{exp.amount || "-"}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="3" className="text-center py-4 text-gray-500">
                                    No expenses found
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
